import { render, staticRenderFns } from "./xiangqing.vue?vue&type=template&id=a8ef5732"
import script from "./xiangqing.vue?vue&type=script&lang=js"
export * from "./xiangqing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports